export default __webpack_public_path__ + "static/media/bunny1_jump.012df48c.png";